import { createLucideIcon } from 'lucide-react';
export const ArrowCircleLeft = createLucideIcon('arrow-circle-left', [
  [
    'path',
    {
      d: 'M10 8L6 11.7601',
      key: '1bocq2',
    },
  ],
  [
    'path',
    {
      d: 'M6 11.7601H18',
      key: 'fi7vxq',
    },
  ],
  [
    'path',
    {
      d: 'M6 11.7601L10 16',
      key: '1emgyt',
    },
  ],
  [
    'circle',
    {
      cx: '12',
      cy: '12',
      r: '10',
      key: '1mglay',
    },
  ],
]);
